export default __webpack_public_path__ + "static/SRF 4220 - Product Specifications & Technical Data-f4e4a7fa610ca72d9dee9c72cc3f78e3.pdf";